import { t } from 'i18next';
import * as yup from 'yup';

import type { IValidationField } from '../types';

export default function requiredPercentage({ label = '' }: IValidationField) {
  return yup
    .number()
    .label(label)
    .min(1)
    .positive()
    .max(100)
    .required()
    .test({
      name: 'valid_integer',
      test: (value, context) => {
        const regex = /^[0-9]*$/g;
        const { originalValue, path = '' } = context;
        if (!originalValue.toString().match(regex)) {
          return context.createError({
            message: t('errors.integerNumber'),
            path: path,
          });
        }

        return true;
      },
    })
    .integer(`${t('errors.integerNumber')}`)
    .typeError(`${t('errors.integerNumber')}`);
}
